export const environment = {
  production: false,
  env: 'test',  
  wsUrl: 'wss://rsstest.akpeisov.kz/ws',
  keycloak: {
    url: 'https://keycloak.akpeisov.kz',
    realm: 'RelaySmartSystemsTest',
    clientId: 'RelaySmartSystemsFront'
  }
}; 